import { supabaseClient } from '../../../utils/supabase';

export const FINANCIAL_REPORT_NAME = 'admin-financial-reports';
export const FINANCIAL_REPORT_QUERY_KEY = ['admin-financial-reports'] as const;
export type MonthlySection = 'business' | 'rep' | 'funder' | 'lead_source' | 'lead_source_total' | 'deal_type' | 'deal_type_total' | 'pipeline' | 'clawback';
export interface MonthlyRow {
  section: MonthlySection;
  month: string | null;
  entity_id: number | null;
  entity_label: string | null;
  is_subtotal: boolean;
  deal_count: number | null;
  allocation_count: number | null;
  funded_amount: number | null;
  commission: number | null;
  psf: number | null;
  gross: number | null;
  david_commission: number | null;
  zack_commission: number | null;
  other_commission: number | null;
  allocated_commission: number | null;
  application_count?: number | null;
  approval_count?: number | null;
  approved_amount?: number | null;
}
export interface FinancialFilterOption {
  kind: 'rep' | 'main_rep' | 'funder' | 'performance' | 'lead_source';
  id: number | null;
  label: string | null;
}
export interface DateRange { start: string | null; end: string | null }
/** Narrows the dashboard to one rep (main or commissioned), funder or lead source. */
export interface DashboardScope { kind: 'rep' | 'funder' | 'lead_source'; id: number }
/** The dashboard's own filters; they combine with each other and with a page scope. */
export interface DashboardFilters { rep?: number | null; funder?: number | null; leadSource?: number | null }
export async function fetchMonthly(range: DateRange, scope?: DashboardScope, filters: DashboardFilters = {}): Promise<MonthlyRow[]> {
  const { data, error } = await supabaseClient.rpc('admin_financial_monthly', {
    start_date: range.start ?? undefined, end_date: range.end ?? undefined, scope_kind: scope?.kind, scope_id: scope?.id,
    rep_id: filters.rep ?? undefined, funder_id: filters.funder ?? undefined, lead_source_id: filters.leadSource ?? undefined,
  });
  if (error) throw new Error('Could not load the funded dashboard. Please retry.');
  return (data ?? []) as unknown as MonthlyRow[];
}
export async function fetchFinancialFilterOptions(): Promise<FinancialFilterOption[]> {
  const { data, error } = await supabaseClient.rpc('admin_financial_filter_options');
  if (error) throw new Error('Could not load report filters. Please retry.');
  return (data ?? []) as FinancialFilterOption[];
}
